<template>
    <div class="regiment">
        <div class="box">
            <div class="flex__center__center box__header">
                <span class="fs_36 c_1a fw_600">正在开团</span>
            </div>
            <div class="box__content">
                <div class="flex__between__center item" v-for="(item,index) in group" :key="index">
                    <div class="flex">
                        <img :src="item.headimgurl" alt="">
                        <div class="flex__null__around ml_10">
                            <div class="flex__between__null">
                                <span class="fs_28 c_1a">{{item.nickname}}&emsp;</span>
                                <span class="fs_24 c_4d lh_40">还差{{item.rest_number}}人成团</span>
                            </div>
                            <span class="fs_22 c_98 lh_30">剩余：{{item.hour}}:{{item.minute}}:{{item.second}}</span>
                        </div>
                    </div>
                    <button @click="attend(item.group_id)">去参团</button>
                </div>
            </div>
            <div class="flex__center__center box__footer">
                <span class="fs_24 c_66">最多仅显示10个正在开团的人</span>
            </div>
        </div>
        <div class="close-box" @click="$router.go(-1)">
            <span class="jcicon jcicon-guanbi fs_50 c_ff"></span>
        </div>
        <!-- 规格 -->
        <sku v-if="sku_show" :sku_show="sku_show" :group_id="group_id" :product_id="product_id" @isSku="isSku"></sku>
    </div>
</template>
<script>
export default {
    name: "Regiment",
    data(){
        return{
            sku_show: false,
            group:[],
            product_id:0
        }
    },
    methods:{
        // 参团
        attend(id){
            this.group_id=id;
            this.sku_show=true;
        },
        // 规格子组件传值
        isSku(data){
            this.sku_show=data;
        },
        // 计算到计时
        countTime(time,interval_obj,callback){
            let current_time = Date.parse(new Date()) / 1000;
            var totalSecond = time - current_time;
            interval_obj = setInterval(function () {
                // 秒数
                var second = totalSecond;
                // 小时位
                var hr = Math.floor((second) / 3600);
                var hrStr = hr.toString();
                if (hrStr.length == 1) hrStr = '0' + hrStr;

                // 分钟位
                var min = Math.floor((second - hr * 3600) / 60);
                var minStr = min.toString();
                if (minStr.length == 1) minStr = '0' + minStr;

                // 秒位
                var sec = second - hr * 3600 - min * 60;
                var secStr = sec.toString();
                if (secStr.length == 1) secStr = '0' + secStr;
                    callback({
                        hrStr,
                        minStr,
                        secStr})
                    totalSecond--;
                if (totalSecond < 0) {
                    clearInterval(interval_obj);
                    this.$toast('活动已结束');
                    return{
                        hrStr:'00',
                        minStr:'00',
                        minStr:'00'
                    }
                }
            }, 1000);
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Collage/getProductDetailData',{
            user_id: localStorage.user_id,
            product_id: this.$route.params.id
        }).then(
            res=>{
                if(res.data.code==1){
                    this.group=res.data.data.group;
                    this.product_id=res.data.data.product.id;
                    for(let i=0;i<this.group.length;i++){
                        this.countTime(this.group[i].end_time,this.group[i].interval,time_res=>{
                            this.$set(this.group[i],'hour',time_res.hrStr);
                            this.$set(this.group[i],'minute',time_res.minStr);
                            this.$set(this.group[i],'second',time_res.secStr);
                        });
                    }
                }
            }
        )
    },
    beforeDestroy(){
        clearInterval(this.interval_obj);
        for(let i=0;i<this.group.length;i++){
           clearInterval(this.group[i].interval);
        }
    }
}
</script>
<style scoped>
.regiment{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, .6);
}
.box{
    position: fixed;
    top: 200px;
    bottom: 200px;
    width: 600px;
    left: 75px;
    background: #fff;
    border-radius: 20px;
}
.box__header{
    position: absolute;
    width: 100%;
    height: 100px;
    border-bottom: 2px solid #e6e6e6;
}
.box__content{
    position: absolute;
    top: 100px;
    bottom: 75px;
    width: 100%;
    overflow: auto;
}
.box__footer{
    position: absolute;
    bottom: 0;
    height: 75px;
    width: 100%;
    border-top: 2px solid #e6e6e6;
}
.item{
    height: 120px;
    padding: 20px 30px;
}
.item img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.item button{
    width:130px;
    height:60px;
    border-radius:4px;
    background: #F93A42;
    font-size: 28px;
    color: #fff;
}
.close-box{
    position: fixed;
    bottom: 120px;
    left: 50%;
    margin-left: -25px;
}
</style>


// WEBPACK FOOTER //
// src/pages/assemble/Regiment.vue